function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Calque 2"
}, React.createElement("g", {
  "data-name": "02_HOME"
}, React.createElement("path", {
  d: "M175.46.5l126.6 117.33c47.73 44.41 63 62.31 94.13 62.31s46.4-25.19 46.4-57.67c0-35.13-17.24-63.63-37.78-93.46v-1.33l80.87 11.93c11.93 22.54 18.55 62.31 18.55 88.16 0 78.22-43.74 118-102.07 118-46.4 0-82.2-28.5-137.88-88.82l-55-58.33 24.53 173V273l-67.63-14V.5zm158.4 328.78c102.74 0 170.35 67 170.35 168.36S436.62 666 333.86 666c-80.21-.66-174.33-57-174.33-168.37.02-114 92.16-169.02 174.33-168.35zm-3.29 271.11c68.27-.67 112-41.76 112-102.75S398.18 394.9 331.23 394.9c-68.27 0-117.37 39.77-117.37 102.74S263 600.39 330.57 600.39zm72.29 212.1l-33.81-86.83h27.81l100.75 106.72v37.12l-331.43 7.29v-78.88zM504.23 1122c0 104.74-70.26 154.45-153.78 154.45-64.3 0-135.22-42.42-182.95-67.61l-167-88.78v-88.16h1.33l232.66 159.74c-25.85-32.48-31.15-60.32-31.15-87.49 0-76.23 68.93-137.88 151.13-137.88s149.76 54.36 149.76 155.73zm-62.3 0c0-59.65-39.11-90.14-87.5-90.14-56.34 0-97.44 31.15-97.44 90.81 0 43.08 29.83 88.16 97.44 88.16 47.06.04 87.5-29.83 87.5-88.83z",
  fill: "#1d1899",
  stroke: "#ffb6d2"
})));

var Svg2019 = function Svg2019(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 504.73 1276.99",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg2019, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2019.94e41943.svg";
export { ForwardRef as ReactComponent };